import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import Fill from '../../../assets/icons/fill.svg';
import type { HelpSection } from '../../../types/Cashier';
import CTAButton from '../../CTAButton/CTAButton';
import Container from '../../Container/Container';
import PaymentMethodDetailsSummary from '../../Deposit/components/PaymentMethodDetailsSummary/PaymentMethodDetailsSummary';

import {
  TXTWCL_Continue_to_deposit,
  TXTWCL_Review_may_take_up_to_48_hours,
  TXTWCL_WeXre_reviewing_your_payment_m_ELL,
  TXTWCL_You_will_get_an_email_when_you_ELL,
  TXTWCL_Your_payment_information_has_b_ELL
} from './DepositPaymentVerificationSummary.messages.json';
import { container, content, info } from './DepositPaymentVerificationSummary.scss';
import HelpSectionContent from './HelpSectionContent/HelpSectionContent';

const DepositPaymentVerificationSummary: React.FC = () => {
  const {
    values: {
      deposit: { type }
    }
  } = useWizardContext();

  const helpSection: HelpSection = {
    title: TXTWCL_WeXre_reviewing_your_payment_m_ELL,
    body: <HelpSectionContent />
  };

  return (
    <Container
      headerProps={{
        title: <Translation {...TXTWCL_Your_payment_information_has_b_ELL} />
      }}
      page={DepositPaymentVerificationSummary}
      pageTopTitle={<Translation {...TXTWCL_Your_payment_information_has_b_ELL} />}
      helpSection={helpSection}
      helpSupportResolver
      showRegulatoryInformation
      showFooter
    >
      <PaymentMethodDetailsSummary type={type} variant="verification" />
      <div className={info}>
        <Translation {...TXTWCL_You_will_get_an_email_when_you_ELL} />
      </div>
      <div className={container}>
        <p className={content}>
          <Fill />
          <Translation {...TXTWCL_Review_may_take_up_to_48_hours} />
        </p>
      </div>
      <CTAButton translation={TXTWCL_Continue_to_deposit} />
    </Container>
  );
};

DepositPaymentVerificationSummary.displayName = 'DepositPaymentVerificationSummary';

export default DepositPaymentVerificationSummary;
